export const ANONYMOUS_ID_QUERY_PARAM = "_aid"
